import config from "../config";

const LEADS_BASE_URL = `${config.apiUrl}/apifabric/product-leads`;
const PRODUCT_LEAD_EMAIL_API = `${config.apiUrl}/api/productLead`;

export const createLeadApi = async (payload) => {
  const res = await fetch(`${LEADS_BASE_URL}/create`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "fabric-access-key": process.env.REACT_APP_FABRIC_ACCESS_KEY,
    },
    body: JSON.stringify(payload),
  });

  const data = await res.json();

  if (!data.success) {
    throw new Error(data.message || "Error occured while creating lead");
  }

  return data;
};

export const updateLeadApi = async (leadId, payload) => {
  const res = await fetch(`${LEADS_BASE_URL}/update/${leadId}`, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      "fabric-access-key": process.env.REACT_APP_FABRIC_ACCESS_KEY,
    },
    body: JSON.stringify(payload),
  });

  const data = await res.json();

  if (!data.success) {
    throw new Error(data?.message || "Error occured while updating lead");
  }

  return data;
};

export const productLeadEmail = async ( formData) => {
  return await fetch(PRODUCT_LEAD_EMAIL_API, {
    method: "POST",
    body: JSON.stringify(formData),
  }).then((res) => {
    if (res.status !== 200) {
      return Promise.reject("Request failed");
    }

    return res.json();
  });
};

export const getLeadProductList = ({productType}) => {
  return fetch(
    `${LEADS_BASE_URL}/product-list?productType=${productType}`,
    {
      method: "GET",
      headers: {
        "fabric-access-key": process.env.REACT_APP_FABRIC_ACCESS_KEY,
      },
    },
  ).then(async (res) => {
    const data = await res.json(); 
    return data;
  });
};
